<template>
  <component :is="component" class="editable" :contenteditable="true" :placeholder="placeholder" v-bind="restOfProps" @input.stop="emitInput" @keydown="$emit('keydown', $event)" v-text="localValue" v-if="isEditing" />
  <component :is="component" :contenteditable="false" v-bind="restOfProps" v-else-if="!$slots.default">
    {{ value }}
  </component>
  <div v-else-if="$slots.default">
    <slot />
  </div>
</template>

<script>
export default {
  props: ['component', 'value', 'isEditing', 'placeholder'],
  data(self) {
    return {
      localValue: self.value,
    };
  },
  computed: {
    restOfProps() {
      var { ...restOfProps } = this.$attrs;
      return restOfProps;
    },
  },
  methods: {
    emitInput(event) {
      return this.$emit('input', event.target.innerText);
    },
  },
  watch: {
    isEditing() {
      this.localValue = this.value;
    },
  }
}
</script>

<style lang="scss" scoped>
[contenteditable] {
  outline: 0 solid transparent;
}
.editable {
  border-bottom: 1px solid;
  min-width: 20px;

  &[placeholder]:empty::before {
    content: attr(placeholder);
    color: #6b6a6a;
  }
}
</style>